<template>
    <div>
        <h4 class="page-header">Clients</h4>
        <div class="header">
            <div class="form__group">
                <label class="label--search">Search</label>
                <Search
                    class="input input__round input--search"
                    placeholder="Search..."
                    @on-value-change="searchValueChanged"
                />
            </div>
            <Button class="btn btn__primary" text="New Client" @on-click="goToCreatePage"/>
        </div>
    <div class="card">
      <table class="has-links" style="width:100%">
          <col width="55%">
          <col width="25%">
          <col width="25%">
        <tr>
          <SortItem title="Name" @set-sort="setSort" sortKey="name" :sort="sort"/>
          <SortItem title="Country" @set-sort="setSort" sortKey="name" :sort="sort"/>
          <SortItem title="Created at" @set-sort="setSort" sortKey="created_at" :sort="sort"/>
        </tr>
        <tr
          @click="goToEdit(client.id)"
          v-for="client in clients.data"
          :key="client.id"
          class="table-row"
        >
          <td>{{client.name}}</td>
          <td>{{client.country_code}}</td>
          <td>{{client.created_at}}</td>
        </tr>
      </table>
    </div>
    <div v-if="clients.last_page && (clients.last_page > 1)" class="paginate__wrapper">
      <paginate
        :page-count="clients.last_page || 1"
        :prev-text="'Prev'"
        :click-handler="onPageChange"
        name="clients"
        :next-text="'Next'"
        :first-last-button="true"
        :container-class="'paginate'"
      ></paginate>
    </div>
  </div>
</template>

<script>
    import Search from "../partials/Search.vue";
    import Button from "../partials/Button.vue";
    import SortItem from '../partials/SortItem.vue'
    import Paginate from "vuejs-paginate";
    import * as api from "./api.js";

    export default {
        name      : "ClientList",
        components: {
            Search,
            Paginate,
            Button,
            SortItem
        },
        created   : async function () {
            document.title = 'Clients | PayGate Invoice'
            this.fetchClients();
        },
        methods   : {
            goToCreatePage() {
                this.$router.push(`clients/create`);
            },
            goToEdit(id) {
                this.$router.push(`clients/${id}`);
            },
            onPageChange      : async function (toPage) {
                this.page = toPage;
                this.fetchClients({page: this.page});
            },
            fetchClients      : async function () {
                this.clients = await api.fetchClients({
                    search: this.search,
                    page  : this.page,
                    filter: this.filter,
                    sort  : this.sort
                });
            },
            setSort(sort) {
                if (this.sort.value == sort) {
                    if (this.sort.direction == "asc") {
                        this.sort.direction = "desc";
                    } else {
                        this.sort.direction = "asc";
                    }
                } else {
                    this.sort.value = sort;
                    this.sort.direction = "asc";
                }
                this.fetchClients()
            },
            searchValueChanged: async function (search) {
                try {
                    this.clients = await api.fetchClients({page: 1, search: search});
                } catch (e) {
                    this.error = "error";
                }
            }
        },
        data() {
            return {
                page   : 1,
                filter : {},
                search : "",
                sort   : {
                    value    : "created_at",
                    direction: "desc"
                },
                clients: []
            };
        }
    };
</script>

<style lang="scss" scoped>
    .button {
        width: 150px;
    }

    .header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }

    .customer-id {
        /*padding-left: 50px;*/
    }
</style>
